import { useEffect, useRef } from "react";

// A button that sends the person to another site (Stripe Checkout or the billing portal) stays in its "Opening..."
// state while the page unloads. When they come back with the browser's Back button, the browser can restore the
// page exactly as it was, frozen in that state. `pageshow` with `persisted` is the signal for that restore, so
// this runs `reset` then. A normal reload starts fresh and needs nothing.
const useResetOnReturn = (reset) => {
  const latest = useRef(reset);
  latest.current = reset;
  useEffect(() => {
    const onShow = (event) => {
      if (event.persisted) latest.current();
    };
    window.addEventListener("pageshow", onShow);
    return () => window.removeEventListener("pageshow", onShow);
  }, []);
};

export default useResetOnReturn;
